import { useEffect, useState } from "react";
import { AuthProvider, useDataProvider } from 'react-admin';
import jwt_decode, { JwtPayload } from "jwt-decode";
import { BASE_URL, SIGN_IN } from "../config";

const authProvider: AuthProvider = {

    login: (data: any) => {
        const request = new Request(`${BASE_URL}${SIGN_IN}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });

        return fetch(request).then(response => {
            if (response.status < 200 || response.status >= 300) {
                throw new Error(response.statusText);
            }
            return response.json();
        }).then((auth) => {
            localStorage.setItem("access_token", auth.accessToken);
            return Promise.resolve();
        }).catch((error) => {
            throw new Error("There has been an error at login")
        });

    },
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem("access_token");
            return Promise.reject({ redirectTo: '/login' });
        }
        return Promise.resolve();
    },
    checkAuth: () => {
        return localStorage.getItem("access_token") ? Promise.resolve() : Promise.reject();
    },
    logout: () => {
        localStorage.removeItem("access_token");
        return Promise.resolve();
    },
    getIdentity: () => {

        interface DecodedToken extends JwtPayload {
            sub: string;
            username: string;
        }

        const token = localStorage.getItem("access_token")

        const decodedToken = jwt_decode<DecodedToken>(token as string);
        const userId = decodedToken.sub;
        const username = decodedToken.username;

        return Promise.resolve({
            id: userId,
            fullName: username,
        })
    },
    getPermissions: () => {
        let decode: any = jwt_decode(`${localStorage.getItem("access_token")}`);
        const user = decode['username'];
        // const user = "property";
        const role = decode['privilege'];
        return role ? Promise.resolve(role) : Promise.reject();
    }
};

export default authProvider;